<style lang="scss">
.agenda-settings-mobile {
  @apply px-2;
  .agenda-settings {
    &__caption {
      @apply justify-center;
      .caption {
        @apply flex-wrap justify-start px-8 pb-2 #{!important};
        &__item {
          @apply w-6/12 m-0 mb-2 justify-start;
        }
      }
    }
  }
  >nav {
    @apply mb-4 mx-auto w-9/12;
  }
  >section {
    @apply flex justify-between;
    .options {
      @apply inline-block;
      >* {
        @apply m-0 mr-2 mt-1 float-left;
      }
      .agenda-settings__agenda-online {
        @apply mt-0;
        width: 70px;
      }
      .days-view {
        @apply w-4 block relative;
        &.collapsed {
          ul {
            @apply flex;
          }
        }
        .ellipsis {
          @apply text-xl ml-1 font-black text-grayMedium no-underline;
          writing-mode: vertical-rl;
          text-orientation: sideways;
        }
        ul {
          @apply p-0 m-0 bg-white hidden absolute top-0 right-0 mt-6 mr-0 z-10 flex-col list-none border border-grayMedium uppercase rounded-md;
          li {
            @apply px-3 py-2 m-0;
            &.selected {
              @apply bg-grayMedium text-white;
            }
          }
        }
      }
    }
  }
}
</style>

<template>
  <div class="agenda-settings-mobile">
    <header>
      <!-- Agenda online -->
      <div
        v-if="hasAppIntegration"
        class="btn btn-primary uppercase !font-normal tracking-widest agenda-settings__agenda-online btn-sm !pl-0 mx-auto mb-4"
        @click.prevent="
          plan.isPro
            ? $store.dispatch('togglePlanModal', { showModal: true, isReminderModal: false })
            : $emit('method', 'openAgendaOnline')
        "
      >
        <span class="btn btn-blue btn-lg btn-action mr-2 shadow-md">
          <dr-icon class="w-4 m-auto" name="agendaShare" fill="white"  />
        </span>
        Divulgue sua agenda
      </div>
      <!-- Legenda -->
      <div class="agenda-settings__caption">
        <ul class="caption">
          <li class="caption__item caption__item--consulta">
            Consulta
          </li>

          <li class="caption__item caption__item--exame">
            Exame/Procedimento
          </li>

          <li class="caption__item caption__item--retorno">
            Retorno
          </li>

          <li class="caption__item caption__item--telemedicina">
            Telemedicina
          </li>
        </ul>
      </div>
    </header>

    <!-- Selecionar semana -->
    <nav v-if="daysView === '3'" class="agenda-settings__week">
      <button
        aria-label="Semana anterior"
        class="agenda-settings__btn"
        @click="$emit('add-week', -1)"
      >
        <i class="agenda-settings__icon agenda-settings__icon--prev" />
      </button>

      <transition name="fade">
        <div class="agenda-settings__current-week">
          {{ currentWeek.label }}
        </div>
      </transition>

      <button
        aria-label="Próxima semana"
        class="agenda-settings__btn"
        @click="$emit('add-week', 1)"
      >
        <i class="agenda-settings__icon agenda-settings__icon--next" />
      </button>
    </nav>

    <section>
      <!-- Calendário -->
      <div
        v-click-outside="() => { $emit('toggled', ['showCalendar', false]) }"
        @click.self="$emit('toggled', ['showCalendar', !showCalendar])"
        class="agenda-settings__date-picker"
      >
        <span @click.self="$emit('toggled', ['showCalendar', !showCalendar])">
          {{ $moment(currentDate).format('DD/MM/YYYY') }}
        </span>

        <dr-icon
          @click.self="$emit('toggled', ['showCalendar', !showCalendar])"
          :color="'#8E8E92'"
          class="agenda-settings__date-picker--icon"
          name="dashCalendar"
        />

        <div class="agenda-settings__date-picker--wrapper">
          <slot></slot>
        </div>
      </div>

      <div class="options">
        <div
          id="options-list-wrapper"
          class="agenda-settings__block relative"
        >
          <img
            v-click-outside="() => showBlockOptions = false"
            :src="require('@/assets/img/lock.png')"
            @mouseenter="showBlockOptions = true"
            @click="showBlockOptions = true"
          >

          <transition name="fade" mode="out-in">
            <ul
              v-if="showBlockOptions"
              id="options-list"
              class="options-list hidden"
              @mouseleave="showBlockOptions = false"
            >
              <li
                title="Bloquear dias de sua agenda (ex.: férias)"
                class="options-list__item"
                @click="$emit('toggled', ['blockModal', true])"
              >
                Bloquear agenda
              </li>

              <li
                title="Clique aqui para desbloquear as agendas em todos os consultórios. Caso queira desbloquear um intervalo específico, busque por ele na agenda do consultório."
                class="options-list__item"
                @click="$emit('method', 'unblockAllAgendas')"
              >
                Desbloquear agenda
              </li>
            </ul>
          </transition>
        </div>

        <!-- Opções de visualização -->
        <div class="days-view"  :class="showDaysView ? 'collapsed' : ''">
          <a v-click-outside="() => showDaysView = false"  @click="showDaysView = !showDaysView" class="ellipsis">...</a>
          <ul>
            <li
              v-for="option in agendaViewOptions"
              :key="`agendaViewOptions-${option.name}`"
              :class="daysView === `${option.daysView}` ? 'selected' : ''"
              class="whitespace-no-wrap"
              @click="$emit('toggled', ['daysView', option.daysView])"
            >
              {{ option.name === 'Semana' ? '3 dias' : option.name }}
            </li>
          </ul>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  name: 'AgendaSettingsMobile',

  props: {
    daysView: {
      type: String,
      default: null
    },

    currentDate: {
      type: String,
      default: null
    },

    agendaWorkingHours: {
      type: Object,
      default: null
    },

    sliderStyle: {
      type: Object,
      default: null
    },

    hasAppIntegration: {
      type: Boolean,
      default: null
    },

    showCalendar: {
      type: Boolean,
      default: false
    },

    agendaInterval: {
      type: String,
      default: null
    },

    currentWeek: {
      type: Object,
      default: null
    },

    agendaViewOptions: {
      type: Array,
      default: null
    }
  },

  data () {
    return {
      showSlider: false,
      sliderValue: null,
      showDaysView: false,
      showBlockOptions: false
    }
  },

  watch: {
    agendaWorkingHours: {
      deep: true,
      handler (next) {
        this.sliderValue[0] = next.start
        this.sliderValue[1] = next.finish
      }
    },

    sliderValue: {
      deep: true,
      handler (next) {
        this.$emit('slider', next)
      }
    },

    showBlockOptions: {
      deep: false,
      immediate: false,
      handler (value) {
        if (value) {
          this.displayBlockOptions()
        }
      }
    }
  },

  mounted () {
    this.sliderValue = [this.agendaWorkingHours.start, this.agendaWorkingHours.finish]
  },

  methods: {
    displayBlockOptions () {
      this.$nextTick(() => {
        const list = document.querySelector('#options-list')
        const wrapper = document.querySelector('#options-list-wrapper')
        const { bottom, right } = wrapper.getBoundingClientRect()

        list.style.top = `${bottom}px`
        list.style.left = `${right - 150}px`
        list.classList.toggle('hidden')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.options-list {
  @apply bg-white fixed p-0 m-0 list-none shadow mt-1 rounded;
  width: 150px;
  z-index: 9000;

  &__item {
    @apply py-1 px-2 m-0 text-sm font-semibold;
    color: darken(#9B9B9B, 10%);

    &:hover {
      background: rgb(226, 226, 226);
    }

    &:first-of-type {
      @apply rounded-t;
    }

    &:last-of-type {
      @apply rounded-b;
    }
  }
}
</style>
